package com.exura.features.plandefinition.usecase

import com.exura.features.firebase.domain.model.versioning.Version
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionMetadata
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.ProviderVersionedTreatmentRepository

class CreateTreatmentPlanUseCase(
    private val repository: ProviderVersionedTreatmentRepository
) {
    suspend operator fun invoke(plan: BasePlan): Result<Version<BasePlan, PlanDefinitionMetadata>> {
        return try {
            repository.create(plan)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
